export default {
  methods: {
    // 四捨五入至小數點後第2位
    // 雖然後端已經對數字做過計算, 但為了讓整數也同樣顯示小數點後兩位, 還是再處理一次
    showDecimal (num, index = 2) {
      if (isNaN(num)) return num
      const newnum = num.toString()
      const snum = newnum.split('.')
      let buz = ''
      if (snum[1] === undefined) {
        buz = Array.from({ length: index }, () => '0').join('')
      } else {
        const arr = snum[1].split('')
        for (let i = 0; i < index; i++) {
          buz += arr[i] ? arr[i] : '0'
        }
      }
      return this.cFormat(snum[0] + '.' + buz)
    },
    cFormat (value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    showOddsText (category, lotto, betInfo) {
      // 未來需要新增多賠率的顯示資料
    }
  }
}
